import { gql } from 'apollo-angular';

/*
 * Recipients by rfp (for the buyer side)
 */
const GET_RFP_RECIPENTS = gql`
  query getRfpRecipients($rfpId: Long) {
    rfp(id: $rfpId) {
      recipients {
        seller {
          id
          name
        }
        offerSubmissionStatistics {
          newSubmissionsCount
          lastSubmissionDate
        },
        status,
        offers {
          id
          name
          status
          submissionDate
          sellerId
        }
      }
    }
  }
`;

export default GET_RFP_RECIPENTS;

